import $ from 'jquery';
import PayLaterBaseMessage from "./PayLaterBaseMessage";

class PayLaterCartMessage extends PayLaterBaseMessage {
    constructor(props) {
        super(props);
        this.cart = props.cart;
    }

    initialize() {
        this.actions.addAction('cart_updated', this.refreshMessage.bind(this));
        super.initialize();
    }

    async refreshMessage() {
        super.initialize();
    }

    getTotal() {
        return this.cart.getTotal();
    }

    getMessageContainer() {
        const location = this.getSetting('cartLocation');
        let el = document.getElementById('wc-ppcp-paylater-msg-cart');
        if (el && this.getSetting('isShortcode')) {
            return el;
        }
        switch (location) {
            case 'shop_table':
                el = document.getElementById('wc-ppcp-paylater-msg-cart');
                break;
            case 'above_button':
                el = document.getElementById('wc-ppcp-cart-button-container');
                if (el) {
                    if (!$(el).find('#wc-ppcp-paylater-msg-cart')?.length) {
                        $(el).prepend('<div id="wc-ppcp-paylater-msg-cart"></div>');
                    }
                    el = document.getElementById('wc-ppcp-paylater-msg-cart');
                }
        }
        return el;
    }

    getPlacement() {
        return 'cart';
    }
}

export default PayLaterCartMessage;

export {PayLaterCartMessage}